/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { SingleFacility } from "../../redux/Slice/Facilities/SingleFacilitySlice";
import { AddUpdateFacilities } from "../../sub-modules";
import { UpdateFacility } from "../../utilities/api/Facilities";
import { FacilityDetailType } from "../../utilities/types";
import { ToastContainer, toast } from "react-toastify";

const UpdateFacilities = () => {
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector((state) => state.singleFacility.isLoading);
  const location = useLocation();
  let id = location.state;
  const navigate = useNavigate();
  const initialState = {
    name: "",
    isActive: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    landmark: "",
    latitude: " ",
    longitude: " ",

  };
  const [facilityData, setFacilityData] =
    useState<FacilityDetailType>(initialState);
  const [submitButton, setSubmitButton] = useState(false);

  useEffect(() => {
    dispatch(SingleFacility(id));
  }, []);
  const SingleFacilityData = useAppSelector(
    (state) => state.singleFacility.SingleFacilityData
  );
  const errorMessage = useAppSelector(
    (state) => state.singleFacility.errorMessage
  );

  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  useEffect(() => {
    if (!isLoading) {
      setFacilityData(SingleFacilityData);
    }
    return () => {
      setFacilityData(initialState);
    };
  }, [isLoading]);

  const handleCreateUpdate = async (payload: FacilityDetailType) => {
    setSubmitButton(true);
    delete payload.id;
    payload.isActive = payload.isActive.toString();
    const result = await UpdateFacility(id, payload);
    if (result.status === 200) {
      navigate("/facilities");
    } else {
      toast.error(result.response.data.message);
    }
    setSubmitButton(false);
  };

  return (
    <>
      <AddUpdateFacilities
        key={facilityData.id}
        name="Edit Facility"
        facilityData={facilityData}
        setFacilityData={setFacilityData}
        handleCreateUpdate={handleCreateUpdate}
        submitButton={submitButton}
      />

      <ToastContainer />
    </>
  );
};

export { UpdateFacilities };
